import { formatNumber } from '@/lib/utils'
import type { components } from '@/api/schema'
import type { QuotedVsActualRow } from './api'

type LeadTime = components['schemas']['QuotedVsActualLeadTime']

export function days(value: number | null | undefined): string {
  if (value == null) return '—'
  return `${formatNumber(value, 1)} ${value === 1 ? 'day' : 'days'}`
}

export function rowName(row: QuotedVsActualRow): string {
  if (row.product) return row.product.model
  if (row.category) return row.category.name
  return row.manufacturer?.name ?? ''
}

export function sourceText(lead: LeadTime): string | null {
  switch (lead.quoted_level) {
    case 'product':
      return 'Product'
    case 'category':
      return lead.quoted_category?.name ?? 'Category'
    case 'manufacturer':
      return 'Manufacturer'
    case 'default':
      return 'Default'
    default:
      return null
  }
}

/** Under "Quoted then": how many of the row's POs predate keeping it. */
export function notRecordedText(notRecorded: number, poCount: number): string | null {
  if (notRecorded === 0) return null
  return notRecorded >= poCount ? 'Not recorded' : `${formatNumber(notRecorded, 0)} not recorded`
}
